import { createElement, Fragment } from "@wordpress/element";

/**
 * External dependencies
 */
import classnames from 'classnames';
/**
 * WordPress dependencies
 */

import { AlignmentControl, BlockControls, Warning, useBlockProps, store as blockEditorStore } from '@wordpress/block-editor';
import { __, sprintf } from '@wordpress/i18n';
import { useSelect } from '@wordpress/data';
import { useEntityProp, store as coreStore } from '@wordpress/core-data';
import { useDisabled } from '@wordpress/compose';
import { createInterpolateElement } from '@wordpress/element';
/**
 * Internal dependencies
 */

import CommentsForm from '../post-comments-form/form';
export default function PostCommentsEdit(_ref) {
  let {
    attributes: {
      textAlign
    },
    setAttributes,
    context: {
      postType,
      postId
    }
  } = _ref;
  let [postTitle] = useEntityProp('postType', postType, 'title', postId);
  postTitle = postTitle || __('Post Title');
  const [commentStatus] = useEntityProp('postType', postType, 'comment_status', postId);
  const {
    avatarURL,
    defaultCommentStatus
  } = useSelect(select => select(blockEditorStore).getSettings().__experimentalDiscussionSettings);
  const isSiteEditor = postType === undefined || postId === undefined;
  const postTypeSupportsComments = useSelect(select => {
    var _select$getPostType;

    return postType ? !!((_select$getPostType = select(coreStore).getPostType(postType)) !== null && _select$getPostType !== void 0 && _select$getPostType.supports.comments) : false;
  });

  let warning = __('Post Comments block: This is just a placeholder, not a real comment. The final styling may differ because it also depends on the current theme. For better compatibility with the Block Editor, please consider replacing this block with the "Comments" block.');

  let showPlaceholder = true;

  if (!isSiteEditor && 'open' !== commentStatus) {
    if ('closed' === commentStatus) {
      warning = sprintf(
      /* translators: 1: Post type (i.e. "post", "page") */
      __('Post Comments block: Comments to this %s are not allowed.'), postType);
      showPlaceholder = false;
    } else if (!postTypeSupportsComments) {
      warning = sprintf(
      /* translators: 1: Post type (i.e. "post", "page") */
      __('Post Comments block: Comments for this post type (%s) are not enabled.'), postType);
      showPlaceholder = false;
    } else if ('open' !== defaultCommentStatus) {
      warning = __('Post Comments block: Comments are not enabled.');
      showPlaceholder = false;
    }
  }

  const blockProps = useBlockProps({
    className: classnames({
      [`has-text-align-${textAlign}`]: textAlign
    })
  });
  const disabledRef = useDisabled();
  return createElement(Fragment, null, createElement(BlockControls, {
    group: "block"
  }, createElement(AlignmentControl, {
    value: textAlign,
    onChange: nextAlign => {
      setAttributes({
        textAlign: nextAlign
      });
    }
  })), createElement("div", blockProps, createElement(Warning, null, warning), showPlaceholder && createElement("div", {
    className: "wp-block-post-comments__placeholder",
    ref: disabledRef
  }, createElement("h3", null,
  /* translators: %s: Post title. */
  sprintf(__('One response to %s'), postTitle)), createElement("div", {
    className: "navigation"
  }, createElement("div", {
    className: "alignleft"
  }, createElement("a", {
    href: "#top"
  }, "\xAB ", __('Older Comments'))), createElement("div", {
    className: "alignright"
  }, createElement("a", {
    href: "#top"
  }, __('Newer Comments'), " \xBB"))), createElement("ol", {
    className: "commentlist"
  }, createElement("li", {
    className: "comment even thread-even depth-1"
  }, createElement("article", {
    className: "comment-body"
  }, createElement("footer", {
    className: "comment-meta"
  }, createElement("div", {
    className: "comment-author vcard"
  }, createElement("img", {
    alt: "Commenter Avatar",
    src: avatarURL,
    className: "avatar avatar-32 photo",
    height: "32",
    width: "32",
    loading: "lazy"
  }), createInterpolateElement(sprintf(
  /* translators: %s: Comment author link. */
  __('%s <span>says:</span>'), sprintf('<cite><a>%s</a></cite>', __('A WordPress Commenter'))), {
    span: createElement("span", {
      className: "says"
    }),
    a:
    /* eslint-disable jsx-a11y/anchor-has-content */
    createElement("a", {
      href: "#top",
      className: "url"
    })
    /* eslint-enable jsx-a11y/anchor-has-content */
    ,
    cite: createElement("cite", {
      className: "fn"
    })
  })), createElement("div", {
    className: "comment-metadata"
  }, createElement("a", {
    href: "#top"
  }, createElement("time", {
    dateTime: "2000-01-01T12:00:00+00:00"
  }, __('January 1, 2000 at 12:00 am'))), ' ', createElement("span", {
    className: "edit-link"
  }, createElement("a", {
    className: "comment-edit-link",
    href: "#top"
  }, __('Edit'))))), createElement("div", {
    className: "comment-content"
  }, createElement("p", null, __('Hi, this is a comment.'), createElement("br", null), __('To get started with moderating, editing, and deleting comments, please visit the Comments screen in the dashboard.'), createElement("br", null), createInterpolateElement(__('Commenter avatars come from <a>Gravatar</a>'), {
    a:
    /* eslint-disable-next-line jsx-a11y/anchor-has-content */
    createElement("a", {
      href: "https://gravatar.com/"
    })
  }))), createElement("div", {
    className: "reply"
  }, createElement("a", {
    className: "comment-reply-link",
    href: "#top",
    "aria-label": sprintf(
    /* translators: Comment reply button text. %s: Comment author name. */
    __('Reply to %s'), __('A WordPress Commenter'))
  }, __('Reply')))))), createElement("div", {
    className: "navigation"
  }, createElement("div", {
    className: "alignleft"
  }, createElement("a", {
    href: "#top"
  }, "\xAB ", __('Older Comments'))), createElement("div", {
    className: "alignright"
  }, createElement("a", {
    href: "#top"
  }, __('Newer Comments'), " \xBB"))), createElement(CommentsForm, null))));
}
//# sourceMappingURL=edit.js.map